$( document ).ready(function() {
  if($(".template-product").length > 0){
    $(".box-beforeAfter #slider").on("input change", (e)=>{
      const sliderPos = e.target.value;
      // Update the width of the foreground image
      $('.foreground-img').css('width', `${sliderPos}%`)
      // Update the position of the slider button
      $('.slider-button').css('left', `calc(${sliderPos}% - 15px)`)
    });
    $(".box--Custom-properties").on("change", "select", function(e){
      var value = $(this).val();
      $(this).parents(".box--Custom-properties").find(".variant-label-option-value").text(value)
    });
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= $(".product-single__add-to-cart .btn--add-to-cart").offset().top) {
            $(".btn--add-to-cart-custom").addClass("is-active");
        } else{
            $(".btn--add-to-cart-custom").removeClass("is-active"); 
        }
    });
  
    $(".product-section").on("click", ".btn--add-to-cart-custom", function(e){
      e.preventDefault();
      $( ".Custom__properties-select .select__select" ).each(function() {    
        $( ".btn--add-to-cart" ).trigger( "click" );
        if( $( this ).val() == null){
          $('html,body').animate({
              scrollTop: $(".product-single__meta").offset().top
          },'slow');
        }
        
      });
    });
  
    $(".dbtfy-upsell_bundles ").on("change", ".Custom__properties_upsell .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      $this.removeClass("invalid");
      $this.parents(".Custom__properties-select").find(".error").removeClass("is-error");
      var value = $this.val();
      
      var html = `<option value="" selected="" disabled="">${Translations.choose_one}</option>`;
      if($(this).data("id") == "brand"){
        $this.parents(".Custom__properties_upsell").find(".Custom__properties-label_value").text(value);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name', `properties[${value} Model]`);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name-properties', `${value} Model`);
        Models.forEach(function(model){
          if(value == model.Brand){
            model.Models.split(/[,]+/).map(function(item){
              return html += `
                <option value="${item}">${item}</option>
              `
            })   
            $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").html(html)
          }
        })
        
      }
    });

    $(".template-product ").on("change", " .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      var ID = $this.parents(".Custom__properties-select").data("id");
      if(ID == "car-make"){
        $this.parents(".Custom__properties-select").siblings().fadeIn();
      }
    });
  }
  if($( ".custom-logo-list-section .custom-logo-list" ).length > 0){
    $( ".custom-logo-list-section .custom-logo-list" ).each(function( index ) {
       var $slider = $(this);
       var slickOptions = {
        arrows: $slider.data("arrows"),
        dots: $slider.data("dots"),
        autoplay: $slider.data("autoplay"),
        autoplaySpeed: $slider.data("autoplayspeed"),
        slidesToShow: $slider.data("count"),
        centerMode: false,
        focusOnSelect: true,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }
        ]
      };
      $slider.slick(slickOptions);
    });
  }
  if($(".template-cart").length > 0){
    var noteCart = localStorage.getItem("noteOrder");
    $(".cart__note textarea").val(noteCart)
    $(".cart-form").on("click", " .cart__checkout", function(e){
      localStorage.removeItem("noteOrder");      
    });
    setTimeout(function () {
      $("#card-footer--input").trigger("click");
    }, 5000); // 5000 milliseconds = 5 seconds
     $(".template-cart").on("change", ".card-footer--checkbox #card-footer--input", function(e){
      var ID = $(this).data("id");
      if($(this).is(":checked")){
        $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: {
              quantity: 1,
              id: ID
           },
           dataType: 'json',
           success: function (data) {
              let cart = jQuery.getJSON('/cart.js');            
              cart.done(function(){
                cart = cart.responseJSON;
                let items = cart.items;
                addCompareAtPrice(cart);               
              })
              function addCompareAtPrice(cart) {
                  cart.items.forEach(function(item) {
                      $.ajax({
                          url: '/products/' + item.handle + '.js',
                          dataType: 'json',
                          async: false,
                          success: function(product) {
                              item["compare_at_price"] = 0;
                              product.variants.forEach(function(variant) {
                                  if (variant.compare_at_price != null && variant.id == item.variant_id) {
                                      item["compare_at_price"] = variant.compare_at_price;
                                  }
                              });
                          }
                      });
                      console.log(item["compare_at_price"])
                  });
                  
                  return cart;
              }
           }
        });        
      } else {
        $.ajax({
           type: 'POST',
           url: '/cart/change.js',
           data: {
              quantity: 0,
              id: ID
           },
           dataType: 'json',
           success: function (data) {

           }
        });
      }
    });
  }
});
